import React from 'react';
import { OperatorType } from '@fabric-ui/components';
import { Box } from '@mui/material';

export const operatorBoxSX = {
  zIndex: 1,
  borderRadius: '10px',
  width: 40,
  fontSize: 12,
  lineHeight: '18px',
  padding: '3px 8px',
  background: theme => theme.palette.colors.neutrals[300],
  fontWeight: 600,
  color: theme => theme.palette.colors.neutrals[600],
  opacity: 1,
};
export const DisabledOperator = ({ operator }: { operator: OperatorType }) => (
  <Box sx={{ ...operatorBoxSX }}>
    <div>{operator.toUpperCase()}</div>
  </Box>
);
